(() => {
 let pending = false;
 const root = (window.Shopify?.routes?.root || document.documentElement.getAttribute('data-shop-root') || '/').replace(/\/?$/, '/');
 async function refreshCount() {
  const response = await fetch(root + 'cart.js', {headers: {Accept: 'application/json'}, credentials: 'same-origin', cache: 'no-store'});
  if (!response.ok) throw new Error('Unable to refresh cart');
  const cart = await response.json();
  if (!Number.isInteger(cart.item_count) || cart.item_count < 0) throw new Error('Invalid cart count');
  document.querySelectorAll('[data-cart-count]').forEach(node => node.textContent = String(cart.item_count));
  document.dispatchEvent(new CustomEvent('jdmpalace:cart-updated', {detail: {itemCount: cart.item_count}}));
 }
 document.addEventListener('submit', async event => {
  const form = event.target;
  if (!form.matches('[data-cart-add]') || !window.fetch || !window.FormData) return;
  // The labelled fixture harness never sends a request to Shopify.
  if (form.hasAttribute('data-offline-form')) return;
  event.preventDefault();
  const feedback = form.querySelector('[data-cart-feedback]');
  const cartLink = form.querySelector('[data-view-cart]');
  const announce = (message, error = false) => {if (feedback) {feedback.textContent = message;feedback.setAttribute('role', error ? 'alert' : 'status');}};
  if (pending) {announce('An item is being added. Please wait.');return;}
  if (!form.reportValidity()) return;
  const button = form.querySelector('[data-add-to-cart]');
  if (!button || button.disabled) return;
  const original = button.innerHTML;
  const optionControls = [...form.querySelectorAll('[data-variant-select],input[type=number][name=quantity]')];
  const controlStates = optionControls.map(control => [control, control.disabled]);
  pending = true;button.disabled = true;form.setAttribute('aria-busy', 'true');announce('Adding to cart…');
  let added = false;
  try {
   const data = new FormData(form);
   data.delete('return_to');
   optionControls.forEach(control => control.disabled = true);
   const response = await fetch(root + 'cart/add.js', {method: 'POST', body: data, headers: {Accept: 'application/json'}, credentials: 'same-origin'});
   const result = await response.json();
   if (!response.ok || result.status >= 400) {
    const error = new Error(typeof result.description === 'string' ? result.description : 'This listing could not be added. Review your cart before trying again.');
    error.shopify = true;throw error;
   }
   added = true;
   announce('Added to your cart.');
   try {await refreshCount();} catch {announce('Added to your cart. Open your cart to check the latest contents.');}
  } catch (error) {
   announce(error.shopify ? error.message : 'Could not confirm the cart update. Check your cart before trying again.', true);
   if (!added) {try {await refreshCount();} catch { /* Never invent a cart count or repeat an uncertain add. */ }}
  } finally {
   if (cartLink) cartLink.hidden = false;
   pending = false;controlStates.forEach(([control, disabled]) => control.disabled = disabled);button.disabled = false;button.innerHTML = original;form.removeAttribute('aria-busy');
  }
 });
})();
